import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { getUserConfig } from '@/slices/userConfigSlice';

const useUserDateFormat = () => {
  const dispatch = useAppDispatch();
  const dispatchFlag = useRef(false);
  const { userConfig, status } = useAppSelector(state => state.userConfig);

  useEffect(() => {
    if (status === 'fulfilled' || dispatchFlag.current) return;
    dispatch(getUserConfig());
    dispatchFlag.current = true;
  }, [status]);

  return userConfig.dateFormat;
};

export default useUserDateFormat;
